import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { getWithdrawl } from '../../api/sportaloka-client';
import * as XLSX from 'xlsx';

const WithdrawlReport = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({
    start_date: format(new Date(), 'yyyy-MM-dd'),
    end_date: format(new Date(), 'yyyy-MM-dd')
  });

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        start_date: paginationOptions.start_date,
        end_date: paginationOptions.end_date
      }).toString();
      const response = await getWithdrawl(query);
      const responseData = response.data.data;
      setData(responseData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      data.map((item) => ({
        Tanggal: format(new Date(item.created_at), 'yyyy/MM/dd HH:mm:ss'),
        // Jenis: item.type,
        Keterangan: item.remarks,
        Jumlah: item.type === 'OUTCOME' ? `IDR ${item.amount.toLocaleString()}` : ''
      }))
    );

    const total = data.reduce((acc, curr) => {
      if (curr.type === 'OUTCOME') return acc + curr.amount;
      return acc;
    }, 0);

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [[], ['Total Penarikan Saldo', '', `IDR ${total.toLocaleString()}`]],
      { origin: -1 }
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Income');
    XLSX.writeFile(workbook, 'LaporanPenarikanSaldo.xlsx');
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end">
        <h1 className="text-30 lh-14 fw-600 mb-0">Laporan Penarikan Saldo</h1>
        <div className="d-flex align-items-end">
          <div className="me-4">
            <label className="fw-semibold text-14">Start Date</label>
            <input
              onKeyDown={(e) => e.preventDefault()}
              onChange={(e) =>
                setPaginationOptions({ ...paginationOptions, start_date: e.target.value })
              }
              value={paginationOptions.start_date}
              type="date"
              className="form-control"
              style={{ border: 'solid 1px #cccccc', backgroundColor: '#ffffff', width: 200 }}
            />
          </div>
          <div>
            <label className="fw-semibold text-14">End Date</label>
            <input
              onKeyUp={(e) => e.preventDefault}
              onChange={(e) =>
                setPaginationOptions({ ...paginationOptions, end_date: e.target.value })
              }
              value={paginationOptions.end_date}
              type="date"
              className="form-control"
              style={{ border: 'solid 1px #cccccc', backgroundColor: '#ffffff', width: 200 }}
            />
          </div>
          <div className="ms-4">
            <button onClick={getData} className="btn btn-small text-white fw-semibold bg-blue-1">
              Filter Data
            </button>
          </div>
          <div className="ms-4">
            <button
              onClick={downloadExcel}
              className="btn btn-small text-white fw-semibold bg-success">
              Download Excel
            </button>
          </div>
        </div>
      </div>
      {loading && !error && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-blue-1">Loading...</p>
        </div>
      )}
      {!loading && error && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-dark">
            Gagal mendapatkan data,{' '}
            <span onClick={getData} className="cursor-pointer text-danger">
              Coba kembali
            </span>
          </p>
        </div>
      )}
      {!loading && !error && data.length === 0 && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-blue-1">Data tidak ditemukan</p>
        </div>
      )}
      {!loading && !error && data.length > 0 && (
        <table className="table table-border table-report mt-40">
          <thead>
            <tr>
              <th className="bg-blue-1 text-white rounded-0">Tanggal</th>
              {/* <th className="bg-blue-1 text-white rounded-0">Jenis</th> */}
              <th className="bg-blue-1 text-white rounded-0">Keterangan</th>
              <th className="text-right bg-blue-1 text-white rounded-0">Jumlah</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{format(new Date(item.created_at), 'yyyy/MM/dd HH:mm:ss')}</td>
                {/* <td>{item.type}</td> */}
                <td>{item.remarks}</td>
                <td className="text-right">
                  {item.type === 'OUTCOME' && `IDR ${item.amount.toLocaleString()}`}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2}>Total</th>
              <th className="text-right">
                IDR{' '}
                {data
                  .reduce((acc, curr) => (curr.type === 'OUTCOME' ? acc + curr.amount : acc), 0)
                  .toLocaleString()}
              </th>
            </tr>
          </tfoot>
        </table>
      )}
    </div>
  );
};

export default WithdrawlReport;
